export const YEAR_UNAVAILALBILITY_WITHOUT_END_DATE = 9999;